export type RawData = any;

export default class RawMapper {
  public map(obj: RawData): RawData {
    return obj;
  }
}
